export default __webpack_public_path__ + "static/media/greenery-mobile.7f46bc9a.jpg";